import * as React from "react";
import { useEffect, useRef, useState } from "react";

export default function ContactFormModal() {
	const modalRef = useRef(null);
	const hubspotScriptLoaded = useRef(false);
	const formRendered = useRef(false);

	useEffect(() => {
		if (!hubspotScriptLoaded.current) {
			const script = document.createElement("script");
			script.src = "https://js.hsforms.net/forms/v2.js";
			script.async = true;
			script.onload = () => {
				hubspotScriptLoaded.current = true;
			};
			document.body.appendChild(script);
		}
	}, []);

	useEffect(() => {
		const modal = modalRef.current;

		const observer = new MutationObserver(() => {
			const modalBody = modal?.querySelector(".uk-modal-body");
			const hasFrame = modalBody?.querySelector(".hs-form-frame");


			if (modalBody && hasFrame  && hasFrame.children.length > 0) {
				const height = hasFrame.offsetHeight;
				modalBody.classList.add("has-form-frame");
			}
		});

		if (modal) {
			observer.observe(modal, {
				childList: true,
				subtree: true,
			});
		}

		return () => observer.disconnect();
	}, []);

	useEffect(() => {
		const modal = modalRef.current;

		const handleBeforeShow = () => {
			if (hubspotScriptLoaded.current && !formRendered.current && window.hbspt) {
				window.hbspt.forms.create({
					portalId: "8290849",
					formId: "2356696b-97b6-49c8-aadc-1a71142e93a4",
					target: "#hubspot-form-container",
				});
				formRendered.current = true;
			}
		};

		if (modal) {
			modal.addEventListener("beforeshow", handleBeforeShow);
		}

		return () => {
			if (modal) {
				modal.removeEventListener("beforeshow", handleBeforeShow);
			}
		};
	}, []);

	return (
		<div
			id="contact-form-modal-footer"
			data-uk-modal
			ref={modalRef}
			style={{ display: "none" }}
		>
			<div className="uk-modal-dialog uk-modal-body">
				<div className="uk-modal-close-default ci-close-btn" data-uk-close></div>
				<div className="uk-flex uk-width-1-1 uk-height-1-1 uk-flex-center uk-flex-middle">
					<div id="hubspot-form-container" className="uk-width-1-1" ></div>
				</div>
			</div>
		</div>
	);
}
